<script setup lang="ts">
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

defineProps<{
    label: string;
    items: string[];
    modelValue: string;
    suffix?: string;
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
}>();
</script>

<template>
    <div class="flex flex-col gap-2">
        <label class="mb-1 font-open text-[13px] font-semibold leading-none text-[#393734]/60">{{ label }}</label>
        <Select :model-value="modelValue" @update:model-value="emit('update:modelValue', $event)">
            <SelectTrigger class-icon="!size-6" class="select-shadow h-14 border-none bg-white !text-[#393734]">
                <SelectValue class="text-lg font-semibold !text-[#393734]">
                    {{ modelValue }}<span v-if="suffix"> {{ suffix }}</span>
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                <SelectItem v-for="val in items" :key="val" :value="val">
                    {{ val }}<span v-if="suffix"> {{ suffix }}</span>
                </SelectItem>
            </SelectContent>
        </Select>
    </div>
</template>

<style>
.select-shadow {
    box-shadow: 0px 1px 4px 0px #39373429;
}
</style>
